export function IntroWhoWeAreSlide({ isActive: _ }: { isActive: boolean }) {
  const stats = [
    { value: "2", label: "Products live" },
    { value: "3", label: "Countries" },
    { value: "15+", label: "Firms on the platform" },
  ];

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row gap-12">
        <div className="flex-1">
          <h2 className="text-[32px] font-light tracking-tight mb-3 font-[family-name:var(--font-heading)]">
            One platform. Multiple regulated industries.
          </h2>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-6">
            COSX builds AI agent infrastructure for industries where compliance is non-negotiable. We give regulated businesses a platform to deploy, manage, and govern AI agents with built-in audit trails, quality control, and professional oversight.
          </p>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
            Our agents are live in legal services and education, with financial services in development. The platform is the same. The compliance layer adapts to each industry.
          </p>
        </div>

        <div className="w-[35%] shrink-0">
          <div className="flex flex-col justify-start w-full pl-10 -my-4 py-4 gap-6 border-l border-[var(--color-border)]">
            {stats.map((stat) => (
              <div key={stat.label}>
                <div className="text-[36px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
                  {stat.value}
                </div>
                <div className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] uppercase tracking-wider">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          We don&apos;t sell tools. We deploy AI agents that work under your
          compliance rules.
        </p>
      </div>
    </div>
  );
}
